export const queryKeys = {
  // Consolidate all your query keys here
  auth: {
    testApi: ["auth", "test-api"] as const,
  },
  posts: {
    all: ["posts"] as const,
    list: () => [...queryKeys.posts.all, "list"] as const,
    detail: (slug: string) => [...queryKeys.posts.all, "detail", slug] as const,
    admin: {
      all: ["admin", "posts"] as const,
      list: () => [...queryKeys.posts.admin.all, "list"] as const,
      detail: (id: number) => [...queryKeys.posts.admin.all, "detail", id] as const,
    },
  },
  projects: {
    all: ["projects"] as const,
    list: () => [...queryKeys.projects.all, "list"] as const,
    detail: (slug: string) => [...queryKeys.projects.all, "detail", slug] as const,
    admin: {
      all: ["admin", "projects"] as const,
      list: () => [...queryKeys.projects.admin.all, "list"] as const,
    },
  },
  siteContent: {
    all: ["site-content"] as const,
    byKey: (key: string) => ["site-content", key] as const,
  },
  experience: {
    all: ["experience"] as const,
    admin: ["admin", "experience"] as const,
  },
  education: {
    all: ["education"] as const,
    admin: ["admin", "education"] as const,
  },
  socialLinks: {
    all: ["social-links"] as const,
    admin: ["admin", "social-links"] as const,
  },
} as const;
